var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { BorderlessButton } from '@citrus/button';
import { styles } from '@citrus/input';
import { getAutomation, getStyleNames } from '@citrus/runtime';
import { isNilOrEmpty } from '@pcty/utils';
import { ClearIconButtonWrapper, ClearSearchIcon } from '../Search.styled';
import { inputActions, inputActionsLarge } from '../../styles/legacy';
var actions = styles.actions;
var ClearButton = function (_a) {
    var _b;
    var ariaLabel = _a["aria-label"], automationId = _a.automationId, disabled = _a.disabled, onClick = _a.onClick, value = _a.value;
    if (disabled || isNilOrEmpty(value))
        return null;
    var emotionObj = (_b = {},
        _b[emotionCss(actions)] = true,
        _b[emotionCss(inputActionsLarge)] = true,
        _b);
    var classes = cx(emotionObj);
    var styleNames = {
        '@citrus/input - actions': emotionObj[emotionCss(actions)],
        inputActions: emotionObj[emotionCss(inputActions)],
        inputActionsLarge: emotionObj[emotionCss(inputActionsLarge)],
    };
    return (React.createElement(ClearIconButtonWrapper, { className: classes, styleNames: getStyleNames(styleNames) },
        React.createElement(BorderlessButton, __assign({ "aria-label": 'Clear ' + ariaLabel, onClick: onClick }, getAutomation(automationId, 'clear')),
            React.createElement(ClearSearchIcon, { disabled: disabled, size: "large" }))));
};
export default ClearButton;
